import { FC } from 'react';
import { MappedAEMProperties } from '../../../types';
import { PageType, usePageDetails } from '../../hooks/usePageDetails';
import AuthoringMessage from '../../../components/dev/AuthoringMessage/AuthoringMessage';

const WithPage = <T extends MappedAEMProperties>(Comp: FC<T>, pageType: PageType[]) => {
  return (props: T) => {
    const { pageType: type } = usePageDetails();
    const { isInEditor } = props;

    if (!pageType.includes(type)) {
      return isInEditor ? (
        <AuthoringMessage>
          <span>That component should be placed only on following pages:</span>
          <p>{pageType.join(', ').replace(/([A-Z])/g, ' $1')}</p>
        </AuthoringMessage>
      ) : null;
    }

    return <Comp {...props} />;
  };
};

export default WithPage;
